/** Only the operations visa view and a canonical order reference are accepted from URLs. */
export function visaRoute(search: string): { visa: boolean; reference: string } {
  const query = new URLSearchParams(search);
  const reference = query.get('reference') ?? '';
  return { visa: query.get('sekme') === 'visa', reference: /^[A-Z0-9-]{8,32}$/.test(reference) ? reference : '' };
}
export function visaOrderHref(reference: string): string | null {
  return /^[A-Z0-9-]{8,32}$/.test(reference) ? `/operasyon?sekme=visa&reference=${encodeURIComponent(reference)}` : null;
}
